"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_dnd_1 = require("react-dnd");
const defaultFieldConfig_1 = require("../constants/defaultFieldConfig");
const FieldTypeCard = ({ icon, label }) => {
    const paperRef = (0, react_1.useRef)(null);
    const baseConfig = defaultFieldConfig_1.defaultFieldConfig[label] || {
        type: label.toLowerCase().replace(/\s+/g, "_"),
        label,
    };
    const dragItem = {
        type: baseConfig.type,
        label: baseConfig.label || label,
        question: baseConfig.label || label,
        placeholder: baseConfig.placeholder,
        options: baseConfig.options,
        config: {
            label: baseConfig.label || label,
            required: false,
            placeholder: baseConfig.placeholder,
            options: baseConfig.options,
        },
    };
    const [{ isDragging }, dragRef] = (0, react_dnd_1.useDrag)(() => ({
        type: "form-element",
        item: dragItem,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    (0, react_1.useEffect)(() => {
        if (paperRef.current) {
            dragRef(paperRef.current);
        }
    }, [dragRef]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { ref: paperRef, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "1px solid #cfcaf7", borderRadius: "12px", bgcolor: "#fff", color: "#6633ff", minHeight: "65px", sx: {
            flex: "1 1 45%",
            cursor: "grab",
            gap: 1,
            transition: "0.2s",
            opacity: isDragging ? 0.5 : 1,
            "&:hover": {
                boxShadow: "0 0 0 2px #cfcaf7",
            },
        }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { fontSize: 16, children: icon }), (0, jsx_runtime_1.jsx)(material_1.Typography, { fontSize: "0.5rem", fontWeight: 600, children: label })] }));
};
exports.default = FieldTypeCard;
